export default "/_next/static/media/image-15-1024x416.97f19f49d5979498de6fd1ce59bedc26.png";